let html = `<div class="screensaver">
    <div class="screensaver__slides">
        <img class="screensaver__slides-one" />
        <img class="screensaver__slides-two" />
    </div>
    <div class="screensaver__gradient"></div>
    <div class="screensaver__datetime">
        <div class="screensaver__datetime-time"><span class="time--clock"></span></div>
        <div class="screensaver__datetime-date"><span class="time--full"></span></div>
    </div>
</div>`

export default html